import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";
import {Observable} from 'rxjs';
import {TableSort} from "../interfaces/table/table-sort";

@Injectable({
  providedIn: 'root'
})
export class QuoteService {
  private readonly apiService = inject(BaseApiService);

  async getQuotes(limit: number, offset: number, search: string, order: TableSort | null, jobTypeId: string | null, statusId: string, statusCategoryId: string | null, locationId: string) {
    const body = {
      offset: offset,
      limit: limit,
      search: search.trim(),
      sort: JSON.stringify(order),
      showInactive: false,
      jobTypeId: jobTypeId == '0' || !jobTypeId ? null : jobTypeId,
      statusId: statusId == '0' || !statusId ? null : statusId,
      statusCategoryId: search.trim() ? null : statusCategoryId,
      locationId: locationId == '0' || !locationId ? null : locationId
    };
    return await this.apiService.post('/quote', body);
  }

  async getQuoteStatus() {
    return await this.apiService.get('/quote/status');
  }

  async getQuoteDetails(id: string) {
    return await this.apiService.get(`/quote/${id}/quote-details`);
  }

  async getQuoteAsset(id: string) {
    return await this.apiService.get(`/quote/${id}/quote-asset`);
  }

  async getQuoteLineItem(id: string) {
    return await this.apiService.get(`/quote/${id}/quote-asset-line-items`);
  }

  async getQuoteHistory(id: string) {
    return await this.apiService.get(`/quote/${id}/quote-details-history`);
  }

  async getQuoteCustomFields(id: string) {
    return await this.apiService.get(`/quote/${id}/quote-custom-fields`);
  }

  ApproveQuote(id: string, quoteData: any): Observable<any> {
    return this.apiService.postObservable(`/quote/${id}/quote-approve`, quoteData);
  }

  DeclineQuote(id: string, quoteData: any): Observable<any> {
    return this.apiService.postObservable(`/quote/${id}/quote-decline`, quoteData);
  }

  RequestChanges(id: string, quoteData: any): Observable<any> {
    return this.apiService.postObservable(`/quote/${id}/quote-request-changes`, quoteData);
  }

  async getQuoteAttachments(id: string, limit: number | null, offset: number | null) {
    const body = {
      quoteID: id,
      limit: limit,
      offset: offset
    }
    return await this.apiService.post(`/quote/attachments`, body);
  }

  async getQuoteComment(id: string) {
    return await this.apiService.get(`/quote/${id}/comments`);
  }

  async createQuoteComment(id: string, commentContent: string) {
    const body = {
      comment_content: commentContent
    }
    return await this.apiService.post(`/quote/${id}/comments`, body);
  }

  updateQuoteComment(id: string, commentId: string, commentContent: string) {
    const body = {
      quote_comment_id: commentId,
      comment_content: commentContent
    }
    return this.apiService.put(`/quote/${id}/comments`, body);
  }

  deleteQuoteComment(id: string, commentId: string) {
    const body = {
      quote_comment_id: commentId
    }
    return this.apiService.post(`/quote/${id}/comments/delete`, body);
  }

  GetQuotePdf(id: string) {
    return this.apiService.post(`/quote/${id}/update-preview`, {});
  }

  async getQuoteExport(jobTypeId: string, quoteStatusId: string, locationId: string, search: string, fileType: string) {
    const body = {
      JobTypeId: jobTypeId == '0' || !jobTypeId ? null : jobTypeId,
      QuoteStatusId: quoteStatusId == '0' || !quoteStatusId ? null : quoteStatusId,
      LocationId: locationId == '0' || !locationId ? null : locationId,
      Search: search.trim(),
      FileType: fileType
    }
    return await this.apiService.post(`/quote/export`, body);
  }
}
